/* Revival: make "One-time purchase" the default in the Bold Subscriptions widget.
   Bold pre-selects the subscription plan. On load (and whenever Bold re-renders the widget,
   for example on variant change) this selects one-time, unless:
   - the page was opened with ?selling_plan= (a deliberate subscribe link), or
   - the shopper has picked a subscription themselves. */
(function () {
  var initial = window.__rvInitialSearch || location.search;
  if (/[?&]selling_plan=/.test(initial)) return;
  var userChoseSub = false;
  var done = new WeakSet();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!e.isTrusted || !t || t.name !== 'bsub-selling-plan-group') return;
    userChoseSub = t.value !== 'once';
  }, true);

  function apply() {
    if (userChoseSub) return;
    document.querySelectorAll('[data-bsub-purchase-option-one-time]').forEach(function (once) {
      if (done.has(once)) return;
      done.add(once);
      if (!once.checked) once.click();
    });
  }

  var tries = 0;
  var timer = setInterval(function () { apply(); if (++tries > 40) clearInterval(timer); }, 250);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
